import { Link } from "react-router-dom";
import { Container } from "../../../shared";
import {
  Building2,
  Landmark,
  Briefcase,
  ShoppingCart,
  MapPin,
  Cpu,
  GraduationCap,
  Image,
} from "lucide-react";

const servicesData = [
  {
    id: 1,
    title: "DSK (Drone Seva Kendra)",
    description: "One stop drone service centers",
    icon: Building2,
    link: "/dsk",
  },
  {
    id: 2,
    title: "Our Institutions",
    description: "Institutions using drones",
    icon: Landmark,
    link: "/training-courses/1",
  },
  {
    id: 3,
    title: "Careers & Jobs",
    description: "Drone industry job listings",
    icon: Briefcase,
    link: "/jobs-hire-page",
  },
  {
    id: 4,
    title: "Marketplace",
    description: "Buy/sell certified drones",
    icon: ShoppingCart,
    link: "/product/all-drone",
  },
  {
    id: 5,
    title: "Drone City Haryana",
    description: "Explore drone hub initiative",
    icon: MapPin,
    link: "/drone-city",
  },
  {
    id: 6,
    title: "Drone Service Centers",
    description: "Service centers for drones",
    icon: Cpu,
    link: "/training-courses/3",
  },
  {
    id: 7,
    title: "Training Programs",
    description: "Pilot certification & courses",
    icon: GraduationCap,
    link: "/training-courses/0",
  },
];

const ServiceCard = ({ service }) => {
  const Icon = service.icon;

  return (
    <Link
      to={service.link}
      className="min-w-[140px] lg:min-w-0 flex flex-col items-center text-center px-1 rounded-md hover:bg-gray-50 cursor-pointer transition-all group"
    >
      {/* Icon */}
      <div className="mb-2 p-1 rounded-md transition">
        <Icon className="w-6 h-6 text-[#0B3C6D]" />
      </div>

      {/* Title */}
      <p className="text-sm font-semibold text-[#0B3C6D]">{service.title}</p>

      {/* Description */}
      <p className="text-xs text-gray-600">{service.description}</p>
    </Link>
  );
};

const Services = ({ data = servicesData, loading = false }) => {
  if (loading) {
    return (
      <section className="py-4">
        <Container>
          <div className="h-24 bg-gray-200 rounded-lg animate-pulse" />
        </Container>
      </section>
    );
  }

  return (
    <Container>
      <div className="bg-white shadow-sm border rounded-lg">
        {/* Header */}
        <div className="flex items-center justify-between bg-[#003580] px-4 py-2 ">
          <h2 className="text-sm font-semibold text-white">Our Services</h2>
          {/* <button className="text-xs text-yellow-400 bg-transparent border-0 font-medium hover:underline">
            View All →
          </button> */}
        </div>

        {/* Services List */}
        <div className="flex overflow-x-auto lg:grid lg:grid-cols-[repeat(auto-fit,minmax(140px,1fr))] p-2">
          {data.map((service) => (
            <ServiceCard key={service.id} service={service} />
          ))}
        </div>
      </div>
    </Container>
  );
};

export default Services;
